import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Button from 'flarum/common/components/Button';
// Flarum 2.0 förväntar sig en direkt export-funktion för forumets startpunkt

app.initializers.add('redundans-star-forum', () => {
  extend(CommentPost.prototype, 'actionItems', function (items) {
    const post = this.attrs.post;
    const discussion = post.discussion(); // Hämta diskussionen som inlägget tillhör
    const canStar = discussion ? discussion.attribute('canStar') || false : false;
    if (!app.session.user || !canStar) {
      return;
    }
    const isStarred = post.attribute('isStarred') || false;
    items.add('star-post', Button.component({
      className: "Button Button--link ".concat(isStarred ? 'Post-starButton--active' : ''),
      icon: isStarred ? 'fas fa-star' : 'far fa-star',
      onclick: () => {
        const newStatus = !isStarred;
        post.save({
          isStarred: newStatus
        }).then(() => {
          m.redraw();
        });
      }
    }, isStarred ? app.translator.trans('redundans-star.forum.starred') : app.translator.trans('redundans-star.forum.star')), 10);
  });
});